import { Component, Input, OnInit } from '@angular/core';
import { SlotModel } from '../../../models/slot.model';
import { GroupModel } from '../../../models/group.model';
import { CandidateModel } from '../../../models/candidate.model';
import { TimerType } from '../../../models/acstatus/ac-status.type';
import { AuthStateService } from '../../../services/auth-state.service';

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss']
})
export class ContentHeaderComponent implements OnInit {

  @Input() title: string = null;
  @Input() slot: SlotModel = null;
  @Input() group: GroupModel = null;
  @Input() candidate: CandidateModel = null;
  @Input() mode: TimerType = TimerType.Exercise;

  constructor(
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
  }

}
